import React from "react";
import { shade } from "polished";
import { Box, Flex } from "rebass";
import styled from "styled-components";

import Text from "./Text";
import H4 from "./Headings/H4";
import StaffProfile from "./StaffProfile";

const Wrapper = styled(Box)``;

Wrapper.defaultProps = {
  px: 4,
  py: 5,
  bg: "grey.1",
};

const StaffBox = styled(Box)`
  padding-top: 24px;
  border-top: 1px solid
    ${(props) =>
      props.theme.colors.grey[1] && shade(0.875, props.theme.colors.grey[1])};
  > * {
    margin-top: 16px;
    &:last-child {
      margin-top: 0;
    }
  }
`;

const Date = styled(Text)`
  font-weight: 600;
  &::selection {
    color: ${(props) => props.theme.colors.grey[2]};
    background-color: ${(props) => props.theme.colors.violet};
  }
`;

const SubDate = styled(Text)`
  font-weight: 500;
  font-size: 12px;
  opacity: 0.66;
  &::selection {
    color: ${(props) => props.theme.colors.grey[2]};
    background-color: ${(props) => props.theme.colors.violet};
  }
`;

const UpdateMeta = (props) => (
  <Wrapper>
    {props.publishDate && (
      <Box mb={1}>
        <Date children={props.publishDate} />
      </Box>
    )}
    {props.updateDate && (
      <Box mb={4}>
        <SubDate children={props.updateText + ": " + props.updateDate} />
      </Box>
    )}
    <StaffBox>
      <StaffProfile
        attributionText={props.attributionText}
        image={props.staffImage}
        name={props.staffName}
        to={props.to}
      />
      {props.secondaryTo &&
        props.secondaryStaffImage &&
        props.secondaryStaffName && (
          <Box pt={2}>
            <StaffProfile
              attributionText={props.attributionText}
              image={props.secondaryStaffImage}
              name={props.secondaryStaffName}
              to={props.secondaryTo}
            />
          </Box>
        )}
    </StaffBox>
  </Wrapper>
);

UpdateMeta.defaultProps = {
  staffImage:
    "https://sidewalklabs.com/assets/uploads/2016/10/eric-jaffe-e1515012031659.png",
  staffName: "Jane Doe",
};

export default UpdateMeta;



// WEBPACK FOOTER //
// ./src/components/UpdateMeta.js